import { HttpClient } from '../models/httpInstance.model'
import useInstanceService from '../services/instance.hook'

const useHttpClient = ({ timeout } = { timeout: 25000 }): HttpClient => {
  const instanceService = useInstanceService()

  const getInstanceWithoutToken = () => {
    return instanceService.createInstance({
      baseURL: process.env.VUE_APP_API_PREFIX_URL,
      timeout,
      withToken: false
    })
  }

  const getEhrInstance = () => {
    return instanceService.createInstance({
      baseURL: process.env.VUE_APP_API_PREFIX_URL,
      timeout
    })
  }

  const getWandaInstance = () => {
    return instanceService.createInstance({
      baseURL: process.env.VUE_APP_WANDA_API_PREFIX_URL,
      timeout
    })
  }

  const getChannelsInstance = () => {
    return instanceService.createInstance({
      baseURL: process.env.VUE_APP_CHANNEL_API_PREFIX_URL,
      timeout
    })
  }

  const getInstance = () => {
    return instanceService.createInstance({ timeout })
  }

  const getUploadInstance = () => {
    return instanceService.createInstance({
      baseURL: undefined,
      timeout: 60000,
      applyCaseMiddlewareOnRequest: false
    })
  }

  const getAosInstance = () => {
    return instanceService.createInstance({
      baseURL: process.env.VUE_APP_SYSTEM_OPS_API_PREFIX_URL,
      timeout
    })
  }

  const getDragonRadarInstance = () => {
    return instanceService.createInstance({
      baseURL: process.env.VUE_APP_DRAGON_RADAR_API_PREFIX_URL,
      timeout
    })
  }

  const getEitaInstance = () => {
    return instanceService.createInstance({
      baseURL: process.env.VUE_APP_EITA_ENDPOINT,
      timeout
    })
  }

  return {
    getAosInstance,
    getChannelsInstance,
    getDragonRadarInstance,
    getEitaInstance,
    getEhrInstance,
    getInstance,
    getInstanceWithoutToken,
    getUploadInstance,
    getWandaInstance
  }
}

export default useHttpClient
